// Types
import type { SocialProfileType } from '@/types/socialProfileType';

// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

const useSelectedSocialProfileById = (id: SocialProfileType['id']) => {
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });

    const selectedSocialProfile = activatedSocialProfiles.find(
        (socialProfile) => socialProfile.id === id
    );

    return { selectedSocialProfile };
};

export default useSelectedSocialProfileById;
